import axios from 'axios';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add company ID header
    const empresaData = localStorage.getItem('empresaActiva');
    let empresaId = '3'; // Default: SOBEK INGENIEROS SUPPLY

    if (empresaData) {
      try {
        // Si es un objeto JSON, extraer el ID
        const parsed = JSON.parse(empresaData);
        empresaId = String(parsed.id || parsed.empresaId || '3');
        console.log('🏢 [API Interceptor] Empresa activa:', parsed.nombreFantasia || parsed.tradeName, '- ID:', empresaId);
      } catch {
        // Si no es JSON, usar el valor directo si es numérico
        if (!isNaN(empresaData)) {
          empresaId = empresaData;
        } else {
          empresaId = '3'; // SOBEK INGENIEROS SUPPLY
        }
        console.log('🏢 [API Interceptor] EmpresaId parseado:', empresaId);
      }
    } else {
      console.log('⚠️ [API Interceptor] No hay empresaActiva en localStorage, usando default:', empresaId);
    }

    config.headers['x-empresa-id'] = empresaId;
    config.headers['x-company-id'] = empresaId;
    console.log('📤 [API Request]', config.method.toUpperCase(), config.url, '- Company ID:', empresaId);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Solo redirigir a login si NO estamos ya en la página de login
      const currentPath = window.location.pathname;
      if (currentPath !== '/login') {
        // Token expired or invalid
        localStorage.removeItem('token');
        localStorage.removeItem('isAuthenticated');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;